import BackgroundImage from 'images/front-page/google-refresh-spotlight.png';

import _t from 'i18n!nls/front-page';

const getGoogleRefreshSpotlightCollectionsData = () => {
  return {
    headline: _t('Popular certificates, new AI skills'),
    description: _t('Get job-ready with Google Professional Certificates—now including  AI skills.'),
    ctaText: _t('View all'),
    ctaTarget: '/google-career-certificates',
    showCtaArrowIcon: true,
    collectionSets: [
      {
        id: 'google-ai-refresh-spotlight',
        context: 'CATEGORY',
        contextId: 'google-ai-refresh-spotlight',
      },
    ],
    backgroundImage: {
      width: 800,
      url: BackgroundImage,
      description: '',
    },
    layout: 'text2/image10',
  };
};

export default getGoogleRefreshSpotlightCollectionsData;
